import {
  // EditOutlined,
  // DesktopOutlined,
  // FileOutlined,
  TeamOutlined,
  PieChartOutlined,
  BankOutlined,
  DollarOutlined,
  UserSwitchOutlined,
  FundProjectionScreenOutlined
} from '@ant-design/icons'

import Dashboard from '../page/Dashboard'
import Banks from '../page/Banks'
import BanksAdd from '../page/Banks/Add'
import BanksEdit from '../page/Banks/Edit'
import Transactions from '../page/Transactions'
import Reports from '../page/Reports'
// import TransactionsAdd from '../page/Transactions/Add'
// import TransactionsEdit from '../page/Transactions/Edit'
import TransactionsView from '../page/Transactions/View'
import Users from '../page/Users'
import Agents from '../page/Agents'
// import User from '../page/User'
// import Posts from '../page/Posts'
// import PostsAdd from '../page/Posts/Add'

const routes = [
  { menu: true, path: '/', roles: ['admin', 'agent'], exact: true, label: 'Dashboard', component: Dashboard, icon: PieChartOutlined },
  { menu: true, path: '/banks', roles: ['admin'], exact: true, label: 'Banks', component: Banks, icon: BankOutlined },
  { path: '/banks/add', roles: ['admin'], exact: true, label: 'Banks', component: BanksAdd },
  { path: '/banks/edit/:id', roles: ['admin'], exact: true, label: 'Banks', component: BanksEdit },
  { menu: true, path: '/transactions', roles: ['admin', 'agent'], exact: true, label: 'Transactions', component: Transactions, icon: DollarOutlined },
  { menu: true, path: '/reports', roles: ['admin', 'agent'], exact: true, label: 'Reports', component: Reports, icon: FundProjectionScreenOutlined },
  // { path: '/transactions/add', roles: ['admin'], exact: true, label: 'Transactions Add', component: TransactionsAdd },
  // { path: '/transactions/edit/:id', roles: ['admin'], exact: true, label: 'Transactions Edit', component: TransactionsEdit },
  { path: '/transactions/view/:id', roles: ['admin', 'agent'], exact: true, label: 'Transactions Edit', component: TransactionsView },
  { menu: true, path: '/users', roles: ['admin'], exact: true, label: 'Users', component: Users, icon: TeamOutlined },
  { menu: true, path: '/agents', roles: ['admin'], exact: true, label: 'Agents', component: Agents, icon: UserSwitchOutlined },
  { path: '/agents/add', roles: ['admin'], exact: true, label: 'Agents', component: Agents, icon: UserSwitchOutlined }
]

export default routes